import { useCallback, useEffect } from 'react';
import { useQuery } from './useQuery';
import { useTimer } from './useTimer';
import { useUserPermissionRequestCheck } from './useUserPermissionRequestCheck';
export const useRequestPermission = ({ permissionName, room, isMuted }) => {
    const requests = useQuery(room.userPermissionRequests);
    const permissions = useQuery(room.userPermissions);

    const { leftTime, permissionRequestCheck } = useUserPermissionRequestCheck(room);

    const handlePermissionRequestCheck = useCallback(() => {
        permissionRequestCheck(permissionName);
    }, [permissionRequestCheck]);

    const timeValue = useTimer({
        onSubmit: handlePermissionRequestCheck,
        remainingTime: leftTime,
    });

    const requestPermission = useCallback(() => {
        room.requestPermission(permissionName);
        handlePermissionRequestCheck();
    }, [room, handlePermissionRequestCheck]);

    useEffect(() => {
        handlePermissionRequestCheck();
    }, [handlePermissionRequestCheck]);

    const isDisabled = isMuted && !permissions?.[permissionName];
    const isActiveRequestPermission = isDisabled && permissions?.canRequestPermission;
    const permission = requests.get(permissionName);
    const isSent = permission && !permission.canRequestAgain;

    return {
        isActiveRequestPermission,
        isSent,
        timeValue,
        requestPermission
    }
};
